
    <p>
      À venir
    </p>

    <button kendoButton="" [primary]="false" routerLink="/auth/login/email">Retour</button>
  


// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/containers/register-contract-page.component.ts.RegisterContractPageComponent.html